<template>
  <div
    class="app-main-content"
  >
    <div class="grid-view">
      <div class="main-content">
        <search-item
          ref="searchItem"
          :show-more-scheme="false"
          :show-simple="false"
          :expand-adv="true"
          config-module="2300"
          :show-adv="true"
          @click-more="value=>{isAdvancedQuery=value}"
          @advSearchItemCallBack="toAdvancedQuery"
        >
          <div slot="operations">
            <el-button no="button1" type="primary" @click="createBillsPayable()">{{
              $t('CargoMsg.Cargo_CreateBillsPayable')
            }}
            </el-button>
            <el-button no="button2" type="primary" @click="lookOrder()">{{ $t('CargoMsg.Cargo_View') }}
            </el-button>
            <el-button no="button3" type="danger" @click="orderDelete()">{{
              $t('CargoMsg.Cargo_OrderDelete')
            }}
            </el-button>
            <el-button no="button4" type="primary" @click="sendSharedCenter('financialAP')">{{
              $t('CargoMsg.Cargo_FinancialPayAreSent')
            }}
            </el-button>
            <el-button no="button5" type="primary" @click="sendSharedCenter('billPayment')">{{
              $t('CargoMsg.Cargo_PaymentRequestSent')
            }}
            </el-button>
            <el-button no="button6" type="primary" @click="querySendResult()">{{
              $t('CargoMsg.Cargo_GetSendResult')
            }}
            </el-button>
            <el-button no="button7" type="primary" @click="editHandler()">{{
              $t('CargoMsg.Cargo_Edit')
            }}
            </el-button>
            <el-button no="button7" type="primary" @click="verificationHandler()">{{ $t('CargoMsg.Cargo_GetTheWriteOffResult') }}</el-button>
          </div>
        </search-item>
        <div class="section grid-wrapper">
          <cargo-ag-grid
            config-module="230002011"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="rowData"
            @gridReady="params=>{gridApi=params.api}"
          />
        </div>
        <div class="pagination-wrapper">
          <cargo-pagination
            config-module="230002012"
            :total="filter.total"
            :page.sync="filter.pageNum"
            :limit.sync="filter.pageSize"
            @pagination="query"
          />
        </div>
      </div>
    </div>

    <!--    付款详情详情 编辑/查看-->
    <payable-detail-dialog
      v-if="detailDialog.visible"
      ref="detailDialog"
      :visible.sync="detailDialog.visible"
      :action="detailDialog.action"
      :merge-type="detailDialog.mergeType"
      :uuids="detailDialog.uuids"
      :title="detailDialog.title"
      @saveResult="saveHandler"
    />
    <!--    创建应付单-->
    <payable-dialog
      v-if="paymentWindow.visible"
      :visible.sync="paymentWindow.visible"
      @saveResult="saveHandler"
    />
    <push-log-dialog
      v-if="pushLogDialog.visible"
      :visible.sync="pushLogDialog.visible"
      :uuid="pushLogDialog.uuid"
    />
  </div>
</template>

<script>
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import ColumnUtils from '@/utils/ColumnUtils'
import { DocumentManage } from '@/utils/commonUtil'
import {
  autoWriteOffFunc,
  pushPreliminaryFunc,
  queryOrderLogFunc
} from '@/api/act/preliminaryEstimate'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import joinChargeDialog from '@/views/cargo/v0/Clearing/components/SharedCenter/joinChargeDialog'
import selectDateDialog from '@/views/cargo/v0/Clearing/components/SharedCenter/selectDateDialog'
import pushLogDialog from '@/views/cargo/v0/Clearing/components/SharedCenter/pushLogDialog'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import PayableDialog from '@/views/cargo/v0/Clearing/components/SharedCenter/payableDialog'
import { advancedQueryApFunc, deleteApFunc } from '@/api/act/financeAp'
import PayableDetailDialog from '@/views/cargo/v0/Clearing/components/SharedCenter/payableDetailDialog'
import { AMOUNT_RECEIVE_TYPES } from '@/class/cargo/model/parameters/ClearingConstants'

export default {
  name: 'BillsPayableQuery',
  components: { PayableDialog, pushLogDialog, searchItem, joinChargeDialog, selectDateDialog, PayableDetailDialog },
  data() {
    return {
      loading: false,
      isAdvancedQuery: false, // 记录上一次操作是否为高级查询
      documentManage: new DocumentManage(),
      SystemConstants,
      pushLogDialog: {
        visible: false,
        uuid: ''
      },
      paymentWindow: {
        visible: false
      },
      detailDialog: {
        visible: false,
        mergeType: false,
        title: '',
        uuids: [],
        action: 'look'
      },
      filter: {
        conditions: {},
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      filterJson: {},
      total: 0,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true, // 如果为true，则不能选择单元格
        suppressRowClickSelection: true, // 如果为true，则单击行时不会发生行选择
        context: { componentParent: this },
        // 选中 勾选框或者其他列 都会触发
        onCellFocused: (event) => {
          this.onCellFocused(event)
        },
        onRowClicked: this.onRowClicked
      },
      columnDefs: [
        {
          headerName: '',
          headerCheckboxSelection: true,
          checkboxSelection: true,
          width: 55,
          pinned: 'left',
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        },

        {
          headerName: this.$t('CargoMsg.Cargo_PaymentSlipDataNo'),
          field: 'tentativeEstimateNo',
          width: 130
        },
        {
          headerName: this.$t('CargoMsg.Cargo_BillDate2'),
          field: 'accountingDate',
          width: 130,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_DateOfApplication'),
          field: 'applyDate',
          width: 130,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_TaxFreeAmount'),
          field: 'excludingTaxAmount',
          width: 130
        },
        {
          headerName: this.$t('CargoMsg.Cargo_IncludedTaxAmount'),
          field: 'amount',
          width: 130
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Currency'),
          field: 'currency',
          width: 130
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Payer'),
          field: 'invoiceTitle',
          width: 130
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Creator'),
          field: 'createdBy',
          width: 130,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_TaxRate'),
          field: 'taxRate',
          width: 130
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Priority'),
          field: 'priority',
          width: 130,
          cellRenderer: params => {
            return ColumnUtils.showTypeLabelFunc(params.value, SystemConstants.PRIORITY_TYPE)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Prepaid'),
          field: 'prepay',
          width: 130,
          cellRenderer: params => {
            return ColumnUtils.showTypeLabelFunc(params.value, SystemConstants.PREPAY_TYPE)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_TypeOfInvoice'),
          field: 'invoiceType',
          width: 130,
          cellRenderer: params => {
            return ColumnUtils.showTypeLabelFunc(params.value, SystemConstants.FINANCE_AP_INVOICE_TYPE)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_UploadInvoiceCloudStatus'),
          field: 'invoiceCloudState',
          width: 130,
          cellRenderer: params => {
            return ColumnUtils.showTypeLabelFunc(params.value, SystemConstants.INVOICE_CLOUD_STATE_LIST)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ReceiveMethod'),
          field: 'receiveType',
          width: 130,
          cellRenderer: params => {
            return ColumnUtils.showTypeLabelFunc(params.value, AMOUNT_RECEIVE_TYPES)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_PayableOrderCreationDate'), colId: 'dateCreated', field: 'dateCreated', width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_AccountToBeCredited'),
          field: 'receiveAccount',
          width: 130
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ReceivingBank'),
          field: 'recipientBank',
          width: 130
        },
        {
          headerName: this.$t('CargoMsg.Cargo_BankConnectionNo'),
          field: 'swiftCode',
          width: 130
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Remarks'),
          field: 'remark',
          width: 130
        },
        {
          headerName: this.$t('CargoMsg.Cargo_OriginalPaymentSlipNo'),
          field: 'payNo',
          width: 130
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ProcessNumber'),
          field: 'processNo',
          width: 130
        },
        {
          headerName: this.$t('CargoMsg.Cargo_FinancialPayStatus'),
          field: 'apState',
          width: 130,
          cellRenderer: (params) => {
            return ColumnUtils.showTypeLabelFunc(params.value, SystemConstants.SHARED_TYPES)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_PaymentRequisitionStatus'),
          field: 'billPaymentState',
          width: 130,
          cellRenderer: (params) => {
            return ColumnUtils.showTypeLabelFunc(params.value, SystemConstants.SHARED_TYPES)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_PushLog'),
          field: 'apState',
          width: 130,
          cellRenderer: (params) => {
            if (!params.data) {
              return ''
            }
            if (params.data.apState !== 1) {
              const uuid = params.data.uuid
              const methodOnFileViewPath = this.documentManage.getPath('onView')
              return `<a onclick="${methodOnFileViewPath}('${uuid}')" style="color:blue">
                    ${this.$t('CargoMsg.Cargo_View')}
                    </a>`
            } else {
              return ''
            }
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_WriteOffStatus'),
          field: 'settleStatus',
          width: 130,
          cellRenderer: (params) => {
            return ColumnUtils.showTypeLabelFunc(params.value, SystemConstants.SHARED_CHARGE_OFF_LIST)
          }
        }
      ],
      doneList: [3, 4, 5],
      noneList: [-1, 1, 2],
      rowData: [],
      selectedData: null,
      gridApi: null
    }
  },
  created() {
    this.toAdvancedQuery([])
  },
  beforeMount() {
    const context = this
    this.documentManage.set('onView', function(value) {
      context.onView(value)
    })
  },
  methods: {
    // 行点击触发事件
    onRowClicked(event) {
      if (!event || !event.data) return
      this.selectedData = null
      const node = event.data
      if (node.uuid) this.selectedData = node
    },
    onCellFocused(event) {
      if (this.gridOptions.api && event.column) {
        this.gridOptions.api.forEachNode(node => {
          if (node.rowIndex === event.rowIndex) {
            this.selectedData = node.data
          }
        })
      }
    },
    handleQueryData(res) {
      this.rowData = res.data.list
      this.filter.pageNum = res.data.pageNum
      this.filter.pageSize = res.data.pageSize
      this.filter.total = Number(res.data.total)
      this.loading.close()
    },
    query(data) {
      this.toAdvancedQuery()
    },
    // 高级查询
    toAdvancedQuery(data) {
      if (typeof data !== 'undefined') {
        this.filterJson.conditions = data
        this.filter.pageNum = 1
      }
      this.filterJson.pageNum = this.filter.pageNum
      this.filterJson.pageSize = this.filter.pageSize
      this.filterJson.branchId = this.$store.getters.currentOfficeId
      this.loading = getLoading4Cxt(this)
      advancedQueryApFunc(this.filterJson).then(res => this.handleQueryData(res)).finally(() => {
        this.loading.close()
      })
    },
    // 创建应付单
    createBillsPayable() {
      this.paymentWindow.visible = true
    },
    saveHandler() {
      this.query()
    },
    // 删除
    orderDelete() {
      const items = this.gridApi.getSelectedRows()
      if (!items || items.length <= 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseChooseData'))
        return
      }
      for (const data of items) {
        if (this.doneList.includes(data.apState)) {
          this.$message.warning(this.$t('CargoMsg.Cargo_SelectNoDeleteAp'))
          return
        }
      }
      const uuids = Array.from(items, p => p.uuid)
      deleteApFunc({ 'uuidList': uuids }).then(res => {
        this.$message.success(this.$t('Menu.SuccessfullyDeleted'))
        this.query()
      })
    },
    // 发送共享中心
    sendSharedCenter(type) {
      const selections = this.gridApi.getSelectedRows()
      if (!selections || selections.length <= 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseChooseData'))
        return
      }
      const keys = []
      for (const data of selections) {
        if (type === 'financialAP') {
          if (this.doneList.includes(data.apState)) {
            this.$message.warning(this.$t('CargoMsg.Cargo_SelectNoPushData'))
            return
          }
        }
        if (type === 'billPayment') {
          if (this.doneList.includes(data.billPaymentState)) {
            this.$message.warning(this.$t('CargoMsg.Cargo_SelectNoPushData'))
            return
          }
          if (data.prepay === 2) {
            this.$message.warning(this.$t('CargoMsg.Cargo_NotPushAP'))
            return
          }
          if (!data.swiftCode) {
            this.$message.warning(this.$t('CargoMsg.Cargo_NotPushAP2'))
            return
          }
        }
        keys.push(data.uuid)
      }
      const filterJson = {}
      filterJson.uuidList = keys
      filterJson.type = type
      filterJson.branchId = this.$store.getters.currentOfficeId
      const loading = getLoading4Cxt(this)
      pushPreliminaryFunc(filterJson).then(res => {
        if (res.data) {
          const data = res.data
          if (data.errorCode) {
            this.$message.warning(ColumnUtils.showTypeLabelFunc(data.errorCode, SystemConstants.ERROR_MAPPING_TYPE))
          } else if (data.syncTip) {
            this.$message.success(ColumnUtils.showTypeLabelFunc(data.syncTip, SystemConstants.ASYNC_MAPPING_TYPE))
          } else {
            this.$message.success(this.$t('CargoMsg.Cargo_SendingResult', [data.successCount, data.failCount]))
            this.query()
          }
        }
      }).finally(() => {
        loading.close()
      })
    },
    // 获取发送结果
    querySendResult() {
      const selections = this.gridApi.getSelectedRows()
      if (selections.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseChooseData'))
        return
      }
      const keys = []
      const bKeys = []
      for (const data of selections) {
        if (this.noneList.includes(data.apState)) {
          this.$message.warning(this.$t('CargoMsg.Cargo_SelectInvoiceAR2'))
          return
        }
        keys.push(data.tentativeEstimateNo)
        // 财务应付单状态等于“审批通过”
        if (data.apState === SystemConstants.SHARED_EXAMINE_APPROVE.code) {
          bKeys.push('P' + data.tentativeEstimateNo)
        }
      }
      if (keys.length === 0 && bKeys.length === 0) {
        this.$message.success(this.$t('CargoMsg.Cargo_SearchCompleted'))
        return
      }
      if (keys.length > 0) {
        this.doQuerySendResult('financialAP', keys)
      }
      if (bKeys.length > 0) {
        this.doQuerySendResult('billPayment', bKeys)
      }
    },
    doQuerySendResult(type, keys) {
      const filterJson = {}
      filterJson.uuidList = keys
      filterJson.type = type
      filterJson.branchId = this.$store.getters.currentOfficeId
      const loading = getLoading4Cxt(this)
      queryOrderLogFunc(filterJson).then(res => {
        if (res.data) {
          if (type === 'billPayment') {
            this.$message.success(this.$t('CargoMsg.Cargo_doTip'))
          }
          this.query()
        }
      }).finally(() => {
        loading.close()
      })
    },
    // 查看
    lookOrder() {
      if (!this.selectedData) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseChooseData'))
        return
      }
      this.detailDialog.visible = true
      this.detailDialog.action = 'look'
      this.detailDialog.title = this.$t('CargoMsg.Cargo_LookAp')
      this.$nextTick(() => {
        this.$refs.detailDialog.onShow(this.selectedData)
      })
    },
    // 编辑
    async editHandler() {
      if (!this.selectedData) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseChooseData'))
        return
      }
      if (this.doneList.includes(this.selectedData.apState) && ![-1, 2].includes(this.selectedData.billPaymentState)) {
        this.$message.warning(this.$t('CargoMsg.Cargo_canNotEdit'))
        return
      }
      this.detailDialog.visible = true
      this.detailDialog.uuids = [this.selectedData.uuid]
      this.detailDialog.action = 'edit'
      this.detailDialog.title = this.$t('CargoMsg.Cargo_EditAp')
      this.$nextTick(() => {
        this.$refs.detailDialog.onShow(this.selectedData)
      })
    },
    async verificationHandler() {
      this.$message.success(SystemConstants.asyncMapping_2.chineseName)
      autoWriteOffFunc()
    },
    onView(value) {
      this.pushLogDialog.visible = true
      this.pushLogDialog.uuid = value
    }
  }
}
</script>
